import { InvoiceScheduleAPI } from '@business/api/invoice_schedule';
import { InvoiceScheduleId, InvoiceScheduleResponse } from '@business/entities/invoiceSetting';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { InvoiceScheduleFormData } from '@modules/invoice/Tabs/InvoiceSchedule/AddEditInvoiceScheduleModal/AddEditInvoiceScheduleModal';
import { switchMap, tap } from 'rxjs/operators';

export class InvoiceScheduleBloc extends BaseBloc {
  private readonly typeRepo = new Repository<InvoiceScheduleResponse>({
    getItemId: item => item.id,
  });

  readonly invoiceSchedule$ = this.typeRepo.items$;
  readonly selectTMFee = this.typeRepo.selectItem;

  onReset() {
    this.typeRepo.reset();
  }

  fetchInvoiceSchedules = () => {
    return InvoiceScheduleAPI.fetchInvoiceSchedules().pipe(
      this.typeRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_invoice_schedule_error') }),
    );
  };

  fetchInvoiceSchedule = (id: InvoiceScheduleId) => {
    return InvoiceScheduleAPI.fetchInvoiceSchedule(id).pipe(
      this.typeRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_invoice_schedule_error') }),
    );
  };

  createInvoiceSchedule = (data: InvoiceScheduleFormData) => {
    return InvoiceScheduleAPI.createInvoiceSchedule(data).pipe(
      this.typeRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_invoice_schedule'),
      }),
    );
  };

  updateInvoiceSchedule = (id: InvoiceScheduleId, data: InvoiceScheduleFormData) => {
    return InvoiceScheduleAPI.updateInvoiceSchedule(id, data).pipe(
      this.typeRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_invoice_schedule'),
      }),
    );
  };

  deleteInvoiceSchedule = (id: InvoiceScheduleId) => {
    return showDeleteConfirmation('Delete Inovice Schedule', 'Do you really want to remove this Inovice Schedule?').pipe(
      switchMap(() => InvoiceScheduleAPI.deleteInvoiceSchedule(id)),
      this.typeRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_invoice_schedule'),
      }),
    );
  };
}
